
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState, useRef, useCallback } from "react";
import AkkhorLayout from "../layout/akkhor";
import AlertErrorForm from "../component/AlertErrorForm";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { confirmAlert } from "react-confirm-alert";
import Spinner from "../component/Spinner";
import { Editor } from '@tinymce/tinymce-react';
import configData from "../configs/config.json";

export default function FormBaiGiangPage() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [detail, setDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [editorMounted, setEditorMounted] = useState(false);
    const editorRef = useRef(null);
    const fileInputRef = useRef(null);

    useEffect(() => {
        setEditorMounted(true); // chạy 1 lần khi mount
    }, []);

    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "learninghub_baigiang_pages/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                setDetail(res.data.data);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id]
    );

    const formik = useFormik({
        initialValues: detail ? detail : { title: '', baigiang_id: 0, page_content: '' },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Vui lòng nhập tiêu đề'),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setTimeout(() => {
                values.page_content = editorRef.current?.getContent();
                setLoading(true)
                if (id > 0) {
                    Axios.put(URL_LIST_ALL + 'learninghub_baigiang_pages/' + id, values, user.config).then(res => {
                        setSubmitting(false);
                        setLoading(false)
                        if (res.data.status === "success") {
                            window.location.reload()
                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch(err => console.log(err));
                } else {
                    // console.log(values);
                    Axios.post(URL_LIST_ALL + 'learninghub_baigiang_pages', values, user.config).then(res => {
                        setSubmitting(false);
                        setLoading(false)
                        if (res.data.status === "success") {
                            window.location.href = '/edit-learninghub_baigiang_pages/' + res.data.id

                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch(err => console.log(err));
                }
            }, 200);
            setSubmitting(false)
        },
    });

    const handleUploadImage = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        try {
            const resizedBlob = await convertImageToBlobAfterResize(file);
            const formData = new FormData();
            formData.append('file', resizedBlob, file.name); // giữ tên gốc
            formData.append('changename', 1);
            formData.append('folder', 0);

            const res = await Axios.post(URL_LIST_ALL + 'fileupload', formData, user.config);
            if (res.data.status === 'success') {
                const imgURL = res.data.message;
                const imgTag = `<img src="${imgURL}" alt="uploaded image" />`;
                if (editorRef.current) {
                    editorRef.current.insertContent(imgTag);
                }
            } else {
                alert("Upload thất bại: " + res.data.message);
            }
        } catch (err) {
            console.error("Lỗi upload ảnh:", err);
            alert("Lỗi upload ảnh");
        }
    };

    const convertImageToBlobAfterResize = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const img = new Image();
                img.src = reader.result;
                img.onload = () => {
                    const maxSize = 2048;
                    const scale = Math.min(maxSize / img.width, maxSize / img.height, 1);
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width * scale;
                    canvas.height = img.height * scale;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    // Chuyển base64 sang blob
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                resolve(blob);
                            } else {
                                reject(new Error("Không thể tạo blob từ canvas"));
                            }
                        },
                        "image/jpeg",
                        1
                    );
                };
                img.onerror = reject;
            };
            reader.onerror = reject;
        });
    };

    const convertYouTubeLinksToIframes = (html) => {
        return html.replace(
            /(?:<p>)?(https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+))(?:<\/p>)?/g,
            (_, __, videoId) => `
            <div class="youtube-embed">
              <iframe 
                src="https://www.youtube.com/embed/${videoId}"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>`
        );
    };
    const handleBlur = () => {
        const content = editorRef.current.getContent();
        const transformed = convertYouTubeLinksToIframes(content);
        if (content !== transformed) {
            editorRef.current.setContent(transformed);
        }
    };

    return (
        <AkkhorLayout idrole="learning_profile_manager">
            <div className="card height-auto mt-5">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Tạo Profile</h3>
                        </div>
                    </div>
                    <form className="new-added-form form-info" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 form-group">
                                <label>Tiêu đề <span className="text-danger">*</span></label>
                                <input type="text" placeholder="VD: Bài học đầu tiên" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>
                            <div className="col-12"></div>

                            <div className="col-12 mt-2 ">
                                <label>Nội dung</label>
                                <div className="modal-body-post">
                                    {editorMounted && (
                                        <Editor
                                            apiKey={configData.tiny_key}
                                            onInit={(_, editor) => (editorRef.current = editor)}
                                            onBlur={handleBlur}
                                            initialValue={formik.values['page_content']}
                                            init={{
                                                height: 300,
                                                menubar: false,
                                                plugins: ['advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen', 'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount', 'emoticons'],
                                                toolbar: 'undo redo | blocks | bold italic forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | emoticons charmap | code | link | help',
                                                placeholder: 'Nhập nội dung mô tả...',
                                            }}
                                        />
                                    )}
                                    <div className="upload-image-post">
                                        <button className="btn btn-outline-info" type="button" onClick={() => fileInputRef.current.click()}>
                                            <i className='fas fa-camera-retro'></i>
                                        </button>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            ref={fileInputRef}
                                            style={{ display: 'none' }}
                                            onChange={handleUploadImage}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-12"></div>

                            <div className="col-12 form-group mt-5">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
